import theme, { colors } from '@globals/themes/defaultTheme'
import { onActive, onFocus, onHover } from '@globals/themes/themeConstants'
import { useRecoveryBannerHeight } from '@globals/useRecoveryBannerStore'
import { useTrialBannerHeight } from '@globals/useTrialBannerStore'
import { SxProps } from '@mui/material/styles'
import { FC, SetStateAction, useState } from 'react'
import NotificationsPopover from './DesktopNotificationsPopover'
import InAppNotificationsButton from './InAppNotificationsButton'

const getButtonStyle = (bannerHeight: number): SxProps => ({
  p: 1,
  position: 'fixed',
  width: 36,
  height: 36,
  boxShadow: colors.boxShadow,
  borderRadius: 100,
  [onHover]: {
    borderRadius: 100,
  },
  [onFocus]: {
    borderRadius: 100,
  },
  [onActive]: {
    borderRadius: 100,
  },
  right: 24,
  top: bannerHeight + 8,
})

const getBadgeStyle = (bannerHeight: number): SxProps => ({
  '& .MuiBadge-badge': {
    backgroundColor: colors.coralPrimary,
  },
  position: 'fixed',
  right: 36,
  top: bannerHeight + 24,
  zIndex: theme.zIndex.appBar + 1,
})

const InAppNotifications: FC = () => {
  const { trialBannerHeight } = useTrialBannerHeight()
  const { recoveryBannerHeight } = useRecoveryBannerHeight()
  const bannerHeight = trialBannerHeight + recoveryBannerHeight
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleOpenNotifications = (event: {
    currentTarget: SetStateAction<HTMLButtonElement | null>
  }) => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseNotifications = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'inAppNotificationsPopover' : undefined

  return (
    <>
      <InAppNotificationsButton
        badgeStyle={getBadgeStyle(bannerHeight)}
        buttonStyle={getButtonStyle(bannerHeight)}
        onClick={handleOpenNotifications}
      />
      <NotificationsPopover
        id={id}
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseNotifications}
      />
    </>
  )
}

export default InAppNotifications
